import { isNil } from 'lodash-es';
import { ProductCategoryInfoVo } from 'typings/openapi';

/** 空值占位符 */
export const EMPTY_PLACEHOLDER = '-';

/**
 * 空值展示：null / undefined / '' / 空数组返回占位符，0、false 原样保留
 * @param value 展示值
 * @param placeholder 占位符，默认 EMPTY_PLACEHOLDER
 */
export function displayValue<T>(value: T, placeholder: string = EMPTY_PLACEHOLDER): NonNullable<T> | string {
  if (isNil(value) || value === '' || (Array.isArray(value) && value.length === 0)) return placeholder;
  return value as NonNullable<T>;
}

// 示例方法，没有实际意义
export function trim(str: string) {
  return str.trim();
}

/**
 * 格式化数字，保留指定小数位数
 * @param value 数值（兼容后端返回的数字字符串）
 * @param digits 保留小数位数，默认 2 位
 * @returns 空值（null/undefined/空字符串/NaN/非法数字）返回 '-'，否则返回格式化后的字符串
 */
export function formatNumber(value?: number | string | null, digits: number = 2) {
  const num = Number(value);
  if (isNil(value) || value === '' || Number.isNaN(num)) return EMPTY_PLACEHOLDER;
  return num.toFixed(digits);
}

export function fomratCategoryIds(arr: any = []) {
  return arr?.map((ids: number[]) => ids?.[ids?.length - 1])?.filter((id: number) => !!id) || [];
}

/**
 * 格式化分类
 * @param productCategoryParentName 一级分类名
 * @param productCategoryName 二级分类名
 * @returns
 */
export function fomartCategoryName(productCategoryParentName?: string, productCategoryName?: string) {
  return [productCategoryParentName, productCategoryName].filter((item) => !!item).join('/') || EMPTY_PLACEHOLDER;
}
/**
 * 通过一级分类名 转换成二级分类数据
 * @param id 一级分类id
 * @param data 分类列表
 * @returns
 */
export function getProductCategoryName(id: number, data?: ProductCategoryInfoVo[]): number[] {
  function findPathRecursive(id: number, currentPath: number[], node?: ProductCategoryInfoVo): any {
    if (node?.id === id) {
      return currentPath.concat(node.id);
    }
    if (node?.childCategoryList?.length) {
      for (let child of node.childCategoryList) {
        const foundPath = findPathRecursive(id, currentPath.concat(node.id || 0), child);
        if (foundPath) {
          return foundPath;
        }
      }
    }
    return null;
  }
  let result: number[] = [];
  data?.forEach((item) => {
    const foundResult = findPathRecursive(id, [], item);
    if (foundResult) {
      result = foundResult;
    }
  });
  return result;
}

/**
 * 构建查询字符串
 * @param query 查询对象
 * @returns 查询字符串
 */
export function buildQueryString(query: Record<string, any>) {
  return Object.entries(query)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
}

/**
 * 隐藏供方名称
 * @param supplierName 供方名称
 * @param isHide 是否隐藏
 * @returns 隐藏后的供方名称
 */
export function hideSupplierName(supplierName: string, isHide: boolean = false) {
  return isHide ? '****' : supplierName;
}

/**
 * 格式化日期区间
 * @param startDate 开始日期
 * @param endDate 结束日期
 * @param separator 连接符，默认「至」
 * @returns 任一侧为空返回 '-'，否则返回 `${startDate}${separator}${endDate}`
 */
export function formatDateRange(startDate?: string | null, endDate?: string | null, separator: string = '至') {
  if (!startDate || !endDate) return EMPTY_PLACEHOLDER;
  return `${startDate}${separator}${endDate}`;
}
